var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "booking-confirmation-common main-content" },
    [
      _c(
        "el-descriptions",
        { attrs: { column: 24, colon: false } },
        [
          _c("el-descriptions-item", {
            attrs: { span: 3.5, label: "Booking Received by Carrier:" }
          }),
          _c(
            "el-descriptions-item",
            { attrs: { span: 3.5 } },
            [
              _c(
                "el-tag",
                {
                  staticStyle: { "margin-left": "5px" },
                  attrs: { type: "info" }
                },
                [_vm._v(_vm._s(_vm.ediReceiptData[_vm.page - 1].time))]
              )
            ],
            1
          ),
          _c(
            "el-descriptions-item",
            { attrs: { span: 17 } },
            [
              _c(
                "el-button",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.showYdBookingResultButton,
                      expression: "showYdBookingResultButton"
                    }
                  ],
                  attrs: { no: "showYdBookingResult" },
                  on: {
                    click: function($event) {
                      return _vm.$emit("showYdBookingResult", "tabVesselEq")
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_ReplaceSystemValue")))]
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "el-descriptions",
        { attrs: { column: 14, colon: false } },
        [
          _c("el-descriptions-item", {
            attrs: { span: 2, label: "Booking Confirmation Version:" }
          }),
          _c("el-descriptions-item", { attrs: { span: 8 } }, [
            _c(
              "div",
              { staticStyle: { display: "flex" } },
              [
                _c("cargo-pagination", {
                  attrs: {
                    layout: "prev, pager, next",
                    limit: 1,
                    page: _vm.page,
                    total: _vm.ediReceiptData.length
                  },
                  on: {
                    "update:page": function($event) {
                      _vm.page = $event
                    }
                  }
                })
              ],
              1
            )
          ]),
          _c("el-descriptions-item", {
            attrs: { span: 2, label: "Latest Amendment Time:" }
          }),
          _c(
            "el-descriptions-item",
            { attrs: { span: 2 } },
            [
              _c("el-tag", { attrs: { type: "info" } }, [
                _vm._v(_vm._s(_vm.lastReceiptTime + " (UTC)"))
              ])
            ],
            1
          )
        ],
        1
      ),
      _vm.ediReceiptData[_vm.page - 1].fileType === "pdf" &&
      _vm.ediReceiptData[_vm.page - 1].pdfSrc
        ? _c(
            "div",
            { staticClass: "pdf-img" },
            [
              _c(
                "el-scrollbar",
                _vm._l(_vm.ediReceiptData[_vm.page - 1].numPages, function(i) {
                  return _c("pdf", {
                    key: i,
                    attrs: {
                      src: _vm.ediReceiptData[_vm.page - 1].pdfSrc,
                      page: i
                    }
                  })
                }),
                1
              )
            ],
            1
          )
        : _vm._e(),
      _vm.ediReceiptData[_vm.page - 1].fileType === "html" &&
      _vm.ediReceiptData[_vm.page - 1].htmlContent
        ? _c("div", [
            _c("div", {
              staticStyle: { "background-color": "white" },
              domProps: {
                innerHTML: _vm._s(_vm.ediReceiptData[_vm.page - 1].htmlContent)
              }
            })
          ])
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }